/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigGarantieItemDto
 */
export interface ConfigGarantieItemDto {
    /**
     * 
     * @type {string}
     * @memberof ConfigGarantieItemDto
     */
    garantieId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigGarantieItemDto
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConfigGarantieItemDto
     */
    franchise?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigGarantieItemDto
     */
    plafond?: number | null;
}

/**
 * Check if a given object implements the ConfigGarantieItemDto interface.
 */
export function instanceOfConfigGarantieItemDto(value: object): value is ConfigGarantieItemDto {
    if (!('garantieId' in value) || value['garantieId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function ConfigGarantieItemDtoFromJSON(json: any): ConfigGarantieItemDto {
    return ConfigGarantieItemDtoFromJSONTyped(json, false);
}

export function ConfigGarantieItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigGarantieItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'garantieId': json['garantieId'],
        'active': json['active'],
        'franchise': json['franchise'] == null ? undefined : json['franchise'],
        'plafond': json['plafond'] == null ? undefined : json['plafond'],
    };
}

export function ConfigGarantieItemDtoToJSON(json: any): ConfigGarantieItemDto {
    return ConfigGarantieItemDtoToJSONTyped(json, false);
}

export function ConfigGarantieItemDtoToJSONTyped(value?: ConfigGarantieItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garantieId': value['garantieId'],
        'active': value['active'],
        'franchise': value['franchise'],
        'plafond': value['plafond'],
    };
}

